import api from '../axios';
/* eslint-disable */
export const apiReportRecord = params => api.post('/user/view/report/liveRecord', params);
